import * as angular from 'angular';

(() => {
    'use strict';

    /**
     * @ngdoc controller
     * @name UploadCtrl
     * @memberof app
     *
     * @description
     * This is the controller for the uploads landing page.
     *
     * @author rowilken.btc
     */
    angular.module('app').controller('UploadsCtrl', UploadsCtrl);

    function UploadsCtrl(
        $location,
        uploadsService,
        $window: ng.IWindowService,
        TransmissionSystemOperator,
        authService,
        growl
    ) {
        type JsonPrimitive = string | number | boolean | null;
        interface JsonMap {
            [member: string]: JsonPrimitive | JsonArray | JsonMap;
        }
        interface JsonArray extends Array<
            JsonPrimitive | JsonArray | JsonMap
        > {}
        type Json = JsonPrimitive | JsonMap | JsonArray;

        this.TransmissionSystemOperator = TransmissionSystemOperator;
        let vm = this;

        uploadsService.setUploadContentType(null);
        vm.UPLOAD_CONTENT = uploadsService.UPLOAD_CONTENT;
        vm.UPLOAD_TYPE = uploadsService.UPLOAD_TYPE;

        authService.getLoggedInUserAsync().then(
            (loggedInUser) => {
                vm.authenticatedUser = loggedInUser;
                vm.TransmissionSystemOperator.isRAConfigurationSupported(
                    { id: vm.authenticatedUser.referenceId },
                    (res) => {
                        vm.isReverseAuctionConfigSupported = res;
                        if (!vm.isReverseAuctionConfigSupported) {
                            delete this.UPLOAD_CONTENT['REVERSE_AUCTION'];
                        }
                        vm.data = {
                            content: this.UPLOAD_CONTENT.PRODUCT,
                            type: this.UPLOAD_TYPE.MANUAL
                        };
                    },
                    (err) => {
                        vm.handlingError();
                    }
                );
            },
            (err) => {
                vm.handlingError();
            }
        );

        vm.handlingError = handlingError;

        function handlingError() {
            growl.show(
                "Could not load the reverse auction configuration. In case you don't want to upload any reverse auctions, please don't take into consideration this error message",
                'danger'
            );
            vm.data = {
                content: this.UPLOAD_CONTENT.PRODUCT,
                type: this.UPLOAD_TYPE.MANUAL
            };
        }

        vm.ui = {
            title: 'New upload',
            networkPointPreselected: false
        };

        var networkPoint = uploadsService.getNetworkPoint();
        if (
            !angular.isUndefined(networkPoint) &&
            !angular.isUndefined(networkPoint.name)
        ) {
            //adjust title to show that nwp has been already selected and disable XML upload option
            this.ui.title += " for '" + networkPoint.name + "'";
            this.ui.networkPointPreselected = true;

            //reset nwp selection //TODO: when nwp selection page is ready, this reset should be moved there
            uploadsService.setNetworkPoint({});
        }

        vm.submit = submit;

        function submit(isValid) {
            if (!isValid) {
                //TODO: handle error
                return false;
            }
            uploadsService.setUploadContentType(vm.data.content);

            if (this.data.type === this.UPLOAD_TYPE.XML_UPLOAD) {
                $location.path('/uploads/xml');
            } else {
                switch (vm.data.content) {
                    case uploadsService.UPLOAD_CONTENT.PRODUCT:
                        $location.path('/uploads/create/product');
                        break;
                    case uploadsService.UPLOAD_CONTENT.NETWORK_POINT:
                        $location.path('/network-point/create');
                        break;
                    case uploadsService.UPLOAD_CONTENT.REVERSE_AUCTION:
                        $location.path('/uploads/create/reverse-auction');
                        break;
                    case uploadsService.UPLOAD_CONTENT.TRADE_PROPOSAL_STATUS:
                        $location.path('/uploads/create/trade');
                        break;
                    case uploadsService.UPLOAD_CONTENT.BALANCING_GROUP:
                        $location.path('/uploads/create/balancing-group');
                        break;
                    case uploadsService.UPLOAD_CONTENT.PORTFOLIO_CODE:
                        $location.path('/uploads/create/portfolio-code');
                        break;
                }
            }
        }
    }
})();
